module.exports = __webpack_public_path__ + "static/media/bezpieczenstwo.4d9024e8.svg";